import { Link } from 'react-router-dom';
import '../../styles/SportsSection.css';
import crick from '../../assets/crick.webp'; 
import foot from '../../assets/foot.webp';
import basket from '../../assets/basket.webp';
import valley from '../../assets/valley.webp';
import tenis from '../../assets/tenis.webp';
import badmin from '../../assets/badmin.webp';

const sportsData = [
  { 
    id: 1,
    name: "Cricket", 
    icon: "🏏", 
    color: "#1a8a3f",
    description: "India's favorite sport. Join tournaments and showcase your batting & bowling skills.",
    events: "12 Events",
    upcoming: "3 Upcoming",
    teams: "48 Teams",
    image: crick,
    link: "/events"
  },
  { 
    id: 2,
    name: "Football", 
    icon: "⚽", 
    color: "#2d7d46",
    description: "The beautiful game. 5-a-side and 11-a-side tournaments for all skill levels.",
    events: "8 Events",
    upcoming: "2 Upcoming",
    teams: "32 Teams",
    image: foot,
    link: "/events"
  },
  { 
    id: 3,
    name: "Basketball", 
    icon: "🏀", 
    color: "#f58220",
    description: "Fast-paced action. Professional and amateur tournaments with amazing prizes.",
    events: "6 Events",
    upcoming: "1 Upcoming",
    teams: "24 Teams",
    image: basket,
    link: "/events"
  },
  { 
    id: 4,
    name: "Volleyball", 
    icon: "🏐", 
    color: "#0077be",
    description: "Beach and indoor volleyball. Teams of 4-6 players competing in thrilling matches.",
    events: "5 Events",
    upcoming: "2 Upcoming",
    teams: "20 Teams",
    image: valley,
    link: "/events"
  },
  { 
    id: 5,
    name: "Tennis", 
    icon: "🎾", 
    color: "#4caf50",
    description: "Singles and doubles tournaments. Professional umpires and state-of-the-art courts.",
    events: "4 Events",
    upcoming: "1 Upcoming",
    teams: "16 Teams",
    image: tenis,
    link: "/events"
  },
  { 
    id: 6,
    name: "Badminton", 
    icon: "🏸", 
    color: "#ff6b6b",
    description: "Fast-paced shuttle action. Singles and doubles categories with exciting prizes.",
    events: "3 Events",
    upcoming: "1 Upcoming",
    teams: "12 Teams",
    image: badmin,
    link: "/events"
  }
];

function SportsSection() {
  return (
    <section className="sps-section-wrapper">
      {/* Animated Background Glows */}
      <div className="sps-bg-glow sps-bg-glow-1"></div>
      <div className="sps-bg-glow sps-bg-glow-2"></div>

      <div className="sps-container">
        {/* Section Header */}
        <div className="sps-header-wrapper">
          <div className="sps-header-left">
            <div className="sps-badge-wrapper">
              <span className="sps-badge-dot"></span>
              <span className="sps-section-badge">⚡ Explore Sports</span>
            </div>
            <h2 className="sps-title">Find Your <span className="sps-title-highlight">Sport</span></h2>
            <p className="sps-subtitle">
              Discover events across multiple sports categories and compete with the best
            </p>
          </div>
          <div className="sps-header-right">
            <div className="sps-stats">
              <div className="sps-stat-item">
                <span className="sps-stat-number">{sportsData.length}+</span>
                <span className="sps-stat-label">Sports</span>
              </div>
              <div className="sps-stat-item">
                <span className="sps-stat-number">38</span>
                <span className="sps-stat-label">Events</span>
              </div>
              <div className="sps-stat-item">
                <span className="sps-stat-number">152</span>
                <span className="sps-stat-label">Teams</span>
              </div>
            </div>
          </div>
        </div>

        {/* Sports Grid */}
        <div className="sps-grid-wrapper">
          {sportsData.map((sport) => (
            <div 
              key={sport.id} 
              className="sps-card-wrapper"
              style={{ 
                borderBottom: `4px solid ${sport.color}`
              }}
            >
              {/* Card Glow Effect */}
              <div className="sps-card-glow"></div>
              
              <div className="sps-card-image">
                <img 
                  src={sport.image} 
                  alt={sport.name}
                  loading="lazy"  // ✅ Lazy Loading Added
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/400x250?text=Sports';
                  }}
                />
                <div className="sps-card-overlay" style={{ background: `${sport.color}cc` }}>
                  <span className="sps-card-icon">{sport.icon}</span>
                </div>
              </div>
              
              <div className="sps-card-body">
                <div className="sps-card-header">
                  <h3 className="sps-name">{sport.name}</h3>
                  <span className="sps-events-badge" style={{ background: `${sport.color}20`, color: sport.color }}>
                    {sport.events}
                  </span>
                </div>
                
                <p className="sps-description">{sport.description}</p>
                
                <div className="sps-stats-row">
                  <div className="sps-stat">
                    <span className="sps-stat-icon">📅</span>
                    <span className="sps-stat-value">{sport.upcoming}</span>
                  </div>
                  <div className="sps-stat">
                    <span className="sps-stat-icon">👥</span>
                    <span className="sps-stat-value">{sport.teams}</span>
                  </div>
                </div>
                
                <Link 
                  to={sport.link} 
                  className="sps-explore-btn" 
                  style={{ borderColor: sport.color, color: sport.color }}
                >
                  Explore Events <span className="sps-btn-arrow">→</span>
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="sps-bottom-cta">
          <p>Don't see your favorite sport? <Link to="/contact">Request a tournament →</Link></p>
        </div>
      </div>
    </section>
  );
}

export default SportsSection;